import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import _ from 'helpers/no_conflict_lodash';

import SelectableRecordTable from "components/selectable_record_table/selectable_record_table";
import SelectionDetails from 'components/selection_details';
import PropertyRow from './property_row';
import PropertiesTableHeader from './properties_table_header';
import {
  toggleSelectAllProperties,
  toggleSelectAllPropertiesOnCurrentPage
} from '../store/actions/select_list';
import { changeSort } from '../store/actions/query';
import { retrieveRecords } from '../store/actions/search';

export class PropertiesTable extends React.Component {
  static propTypes = {
    changeSort: PropTypes.func.isRequired,
    properties: PropTypes.array.isRequired,
    propertyIds: PropTypes.array.isRequired,
    resetSelection: PropTypes.func.isRequired,
    resetSelectionOnCurrentPage: PropTypes.func.isRequired,
    retrieveRecords: PropTypes.func.isRequired,
    selectedPropertyIds: PropTypes.array.isRequired,
    sort: PropTypes.string,
    toggleSelectAll: PropTypes.func.isRequired,
    toggleSelectAllOnCurrentPage: PropTypes.func.isRequired
  };

  // ####################### Table Sort Functions #######################
  handleSortChange = (sortOption) => {
    const { changeSort, retrieveRecords } = this.props;

    changeSort(sortOption);
    retrieveRecords();
  }
  // ####################### Table Sort Functions End####################

  allSelected() {
    return _.every(this.props.properties, property => this.isSelected(property.id)) && this.props.properties.length > 0;
  }

  someSelected() {
    return _.some(this.props.properties, property => this.isSelected(property.id)) && this.props.properties.length > 0;
  }

  includeSearchResults() {
    const { properties } = this.props;
    return properties && properties.length > 0 && properties[0].searchResults != null;
  }

  isSelected(propertyId) {
    return this.props.selectedPropertyIds.indexOf(propertyId) > -1;
  }

  render() {
    const { toggleSelectAllOnCurrentPage, sort, resetSelectionOnCurrentPage } = this.props;
    const columnHeaders = (
      <PropertiesTableHeader
        includeSearchResults={this.includeSearchResults()}
        sort={sort}
        onSortChange={this.handleSortChange}
      />
    );

    return (
      <React.Fragment>
        <SelectableRecordTable
          columnHeaders={columnHeaders}
          selectAllChecked={this.allSelected()}
          selectNoneVisible={this.someSelected()}
          onResetSelection={resetSelectionOnCurrentPage}
          onSelectAllToggle={toggleSelectAllOnCurrentPage}
        >
          <SelectionDetails
            forTable
            label="property"
            selectedCount={this.props.selectedPropertyIds.length}
            totalCount={this.props.propertyIds.length}
            onClearSelection={this.props.resetSelection}
            onSelectAll={this.props.toggleSelectAll}
          />
          {this.renderProperties()}
        </SelectableRecordTable>
      </React.Fragment>
    );
  }

  renderProperties() {
    const { properties } = this.props;
    return _.map(properties, property => (
      <PropertyRow
        key={property.id}
        property={property}
        selected={this.isSelected(property.id)}
      />
    ));
  }
}

const mapStateToProps = state => ({
  selectedPropertyIds: state.selectList.selectedPropertyIds,
  sort: state.query.propertySort
});

const mapDispatchToProps = {
  retrieveRecords,

  changeSort: changeSort,
  toggleSelectAll: toggleSelectAllProperties,
  toggleSelectAllOnCurrentPage: toggleSelectAllPropertiesOnCurrentPage
};

export default connect(mapStateToProps, mapDispatchToProps)(PropertiesTable);
